import { render, staticRenderFns } from "./tab-new.vue?vue&type=template&id=0eb27f2c"
import script from "./tab-new.vue?vue&type=script&lang=js"
export * from "./tab-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports